// extracted by mini-css-extract-plugin
module.exports = {"button":"_3Yr7O","waiting":"_2CMkS","indicator":"_1XvxG"};